declare function CallTrack_function(page,RepName,ProductName,terms, usage500, usageObj1000, usage2000, zipcode, utility_name,enrollmentStatus,Email): void;
declare function TriggerEventBeforeSubmitOrder(provider,term_months,plan_name,zip_code,tdu,flow_type): void;
declare function TriggerEventWhenOrderSuccess(enrollment_id,provider,term_months,plan_name,zip_code,tdu,flow_type): void;
declare function TriggerEventWhenOrderFailed(error_code,error_source,provider,term_months,plan_name,zip_code,tdu,flow_type,error_step): void;
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
  Renderer2,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { FormBuilder, FormGroup } from '@angular/forms';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { states } from '../../../../../assets/js/states';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

const filesize = require('filesize');
declare var setupTransactisPaymentAccounts: Function;
declare var getDepositTempValue: Function;

@Component({
  selector: 'app-depositrequired4ce',
  templateUrl: './depositrequired4CE.component.html',
  styleUrls: ['./ssn-check.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class DepositRequired4CEComponent implements OnInit, OnDestroy {
  @ViewChild('errorStatus4CE', { static: true }) errorStatus4CE: ElementRef;
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  ssndepostList;
  isChecked = false;
  elem4;
  elem5;
  elem6;
  elem7;
  elem8;
  elem44;
  elem55;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  ansinSSncheck2;
  timer;
  time = 1000;
  timeTrue = false;
  hideHome = false;
  url = environment.api_url;
  uploadedFilename = [];
  display = 'none';
  hasAnotherDropZoneOver = false;
  invalidFileSizeMsg = false;
  errorMsg = false;
  invalidFileMsg = false;
  vishome;
  user_bot;
  isDisable = false;
  modalRef: BsModalRef;
  accountNumber;
  productName;
  waiverReasons;
  reason;
  victimreason = false;
  seniorcitizen = false;
  paymenthistory = false;
  activehospitalemp = false;
  emailorfax = false;
  isuploadfile = false;
  isAmex = false;
  postResponseMessage: string;
  waiverreasons = [
    'Select one',
    'I can provide 12 months of good payment history',
    'Senior Citizens in Good Standing',
    'Victim of Family Violence',
    'Medically Indigent',
    // "Active Hospital Employee",
    'Active Military Duty',
  ];
  providewaystocontact = ['Select one', 'Send via email or fax', 'Upload file'];

  addressId;
  Applyforadepositwaiver = false;
  payDeposit = false;
  activemilateryduty = false;
  activemedicalindigent = false;
  formattedCardNumber;
  dragOver: boolean;
  filelength;
  waiverReason;
  wayofcontact;
  statesArr;
  state = 'TX';
  street_address;
  city;
  apt;
  zipcode;
  carddetail;
  month;
  year;
  secuiritycode;
  cardName;
  accpetterms;
  formData: FormData;
  depositamount;
  label;
  updata;
  showmontherr = false;
  validCard = false;
  cvvValid = false;

  uploadForm: FormGroup;
  cityisNull = false;
  ccodeisNull = false;
  street_addressisNull = false;
  zipcodeisNull = false;
  dumbcardno: string;
  checkCardName = false;

  selectedFile: File = null;
  listofFiles = [];
  blankmontherr = false;
  blankyearerr = false;
  zipInvalidLength = false;
  yearErrorFlag = false;
  errorMessage: string;
  depositRequired4CE: any;
  depositAmount4CE: any;
  autoPay4CE: boolean;
  acceptAutoPay = false;
  acceptNoAutoPay = false;
  description: any;
  depositPaymentOptions: {
    clientJavaScriptUrl: string;
    clientJavaScriptHost: string;
    clientJavaScriptAccessToken: string;
  };
  depositTitleMobile: string;
  autoPayment = false;
  automonth: string;
  autoyear: string;
  autosecuiritycode: string;
  autocardName: string;
  autostreet_address: string;
  autocity: string;
  autostate: string;
  autozipcode: string;
  autodescription: string;
  formattedAutoCardNumber: any;
  autodumbcardno: string;
  formattedCard: string;
  userResponses: any;
  autoPayCCTPAT: string;
  depositCCTPAT: string;
  autoPayOption = false;
  isVisa: boolean;
  isMast: boolean;
  isDisc: boolean;
  cardNumberDetails: string;
  cardNumberDisplay: any;
  newVal: any;
  maxLength: number;
  cardValue: any;
  cardType: string;
  prevSize: number;
  autoCardNumberDisplay: any;
  autoPay = false;
  autoCardValue: any;
  checkBoxValue = false;
  public uploader: FileUploader = new FileUploader({
    url: this.url + '/fileupload',
    itemAlias: 'photo',
  });
  private loadCardTypeDetails = {
    startWith3: this.validateAmexCardDetails.bind(this),
    startWith4: this.validateVisaCardDetails.bind(this),
    startWith5: this.validateMasterCardDetails.bind(this),
    startWith6: this.validateDiscoveryDetails.bind(this),
  };
  private depositTitle = {
    noAutoPay:
      'It looks like a deposit and<br /> autopay is required to sign up for this plan',
    autoPay:
      'It looks like setting up <br /> autopay is required to sign up for this plan',
  };
  private loadServiceTypeObject = {
    NewService: this.assignServiceTypeValuesForNewService.bind(this),
    SwitchingProviders:
      this.assignServiceTypeValuesForStandardSwitch.bind(this),
  };
  private loadCompleteEnrollment = {
    Success: this.saveEnrollmentOrderDetails.bind(this),
  };
  private loadCardNumberFormatting = {
    Visa: this.setAllCardNumberFormat.bind(this),
    Master: this.setAllCardNumberFormat.bind(this),
    Discover: this.setAllCardNumberFormat.bind(this),
    Amex: this.setAmexCardNumberFormat.bind(this),
  };
  private loadAutoCardNumberFormatting = {
    Visa: this.setAllAutoCardNumberFormat.bind(this),
    Master: this.setAllAutoCardNumberFormat.bind(this),
    Discover: this.setAllAutoCardNumberFormat.bind(this),
    Amex: this.setAutoAmexCardNumberFormat.bind(this),
  };
  private loadCreditCardErrorMessages = {
    card1Error:
      'We are unable to process your payment. Please verify your 1st credit card details and try again.',
    card2Error:
      'We are unable to process your payment. Please verify your 2nd credit card details and try again.',
    both: 'We are unable to process your payment. Please verify your both credit card details and try again.',
  };
  private monthList = [
    { Value: '01', Text: '01' },
    { Value: '02', Text: '02' },
    { Value: '03', Text: '03' },
    { Value: '04', Text: '04' },
    { Value: '05', Text: '05' },
    { Value: '06', Text: '06' },
    { Value: '07', Text: '07' },
    { Value: '08', Text: '08' },
    { Value: '09', Text: '09' },
    { Value: '10', Text: '10' },
    { Value: '11', Text: '11' },
    { Value: '12', Text: '12' },
  ];
  yearsList: any;
  showAutoMmontherr: boolean;
  autoYearErrorFlag: boolean;
  cvvAutoValid: boolean;
  autoapt: string;
  autoCardType: string;
  checkAutoCardName: boolean;
  autostreet_addressisNull: boolean;
  autocityisNull: boolean;
  autozipcodeisNull: boolean;
  autozipInvalidLength: boolean;
  private loadAutoPayAndDepositObjects = {
    autoPayDepositRequired: this.autoPayDepositRequiredObject.bind(this),
    autoPayRequired: this.autoPayRequiredObject.bind(this),
  };
  cccodeisNull: boolean;
  depositNowWithPayAndAutoPay: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private modalService: BsModalService,
    private _scrollToService: ScrollToService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService
  ) {
    this.yearsList = this.residentialService.autoGenerateYears();
    this.statesArr = Object.keys(states);
    if (
      this.residentialService.enrollmentPostResult !== undefined &&
      JSON.parse(this.residentialService.enrollmentPostResult)
    ) {
      let deamount = JSON.parse(
        this.residentialService.enrollmentPostResult
      ).DepositAmount;
      this.depositamount = deamount.split('.')[0];
      this.label = 'Pay the ' + this.depositamount + ' deposit';
    }
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.getProviderInfo();
    this.deviceWidth = window.innerWidth;
    this.ssndepostList = {
      value4: false,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
  }

  renderExternalScript(url: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  ngOnInit() {
    this.loadScript();
    if (this.residentialService.enrollmentPostObject) {
      var postObj = this.residentialService.enrollmentPostObject;
      this.street_address = postObj.CreditCheckAddress.Street1;
      this.autostreet_address = postObj.CreditCheckAddress.Street1;
      this.city = postObj.CreditCheckAddress.City;
      this.autocity = postObj.CreditCheckAddress.City;
      this.state = postObj.CreditCheckAddress.StateName;
      this.autostate = postObj.CreditCheckAddress.StateName;
      this.zipcode = postObj.CreditCheckAddress.PostCode;
      this.autozipcode = postObj.CreditCheckAddress.PostCode;
      this.apt = postObj.CreditCheckAddress.Apt;
      this.autoapt = postObj.CreditCheckAddress.Apt;
    }
    if (this.residentialService.depositPaymentOption) {
      this.depositPaymentOptions = this.residentialService.depositPaymentOption;
      const creditCheck4CE = this.residentialService.creditCheckResult4CE;
      this.depositRequired4CE = creditCheck4CE.depositRequired4CE;
      this.depositAmount4CE = creditCheck4CE.depositAmount4CE;
      this.autoPay4CE = creditCheck4CE.autoPay4CE;
    }
    this.depositNowWithPayAndAutoPay =
      this.autoPay4CE && this.depositAmount4CE === 0
        ? 'Setup EZ Pay Now'
        : 'Pay Deposit Now';
  }

  setDepositTitleValue() {
    return this.depositTitle[this.autoPay4CE ? 'autoPay' : 'noAutoPay'];
  }

  setMobileDepositTitleValue() {
    return this.autoPay4CE
      ? 'Autopay Required'
      : 'Deposit and Autopay Required';
  }

  setDepositLabelValue() {
    return this.autoPay4CE
      ? 'Setup autopay'
      : 'Pay the deposit and setup autopay';
  }

  @ViewChild('txtCardNumber', { static: true }) txtCardNumber: ElementRef;
  onChangeRole(event) {
    this.isChecked = event.target.checked;
    if (this.deviceWidth < 768) {
      this.elem44 = document.getElementById('payfordepositt');
      this.elem55 = document.getElementById('applydepositwaiverr');
    } else {
      this.elem4 = document.getElementById('payfordeposit');
      this.elem5 = document.getElementById('applydepositwaiver');
    }
    if (this.isChecked) {
      this.payDeposit = true;
      this.ssndepostList = {
        value4: true,
        value5: false,
        value6: false,
        value7: false,
        value8: false,
      };
    } else {
      this.ssndepostList = {
        value4: false,
        value5: false,
        value6: false,
        value7: false,
        value8: false,
      };
    }
  }

  onChangeApplyAnotherProvider(event) {
    if (event.target.checked) {

      sessionStorage.removeItem("selectedEnergyProvider");


      var ProductTypeSelectList = [];
      ProductTypeSelectList.push("Prepaid")
      sessionStorage.setItem(
        'selectedProductType',
        JSON.stringify(ProductTypeSelectList)
      );
  
      
      var Term = [];
      Term.push("Compare")
      sessionStorage.setItem(
        'selectedProviderData',
        JSON.stringify(Term)
      );


      this.router.navigate([
        'recommendation/compare-product',
        this.recommendationService.hg_accountId,
      ]);
    }
  }

  validateName(name) {
    if (name.target.val.match(/^[a-zA-Z]+$/)) {
      $(this).val(name.target.val.replace(/^[a-zA-Z]+$/, ''));
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  hideModal(value) {
    this.ssndepostList = {
      value4: true,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
    this.modalRef.hide();
  }

  @HostListener('document:backbutton', ['$event'])
  onPopState(event) {
    alert('Start page');
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onChangeTxtCardNumber(event) {
    this.postResponseMessage = '';
    const cardValue = event.target.value;
    this.cardValue = cardValue;
    this.dumbcardno = this.cardValue;
    this.autoPay = false;
    if (cardValue.length === 0) this.clearCardClassLists('auto');
    this.cardType =
      cardValue.length > 0 ? this.getCardTypeValues(cardValue.charAt(0)) : '';
    if (cardValue.length > 0)
      this.loadCardTypeDetails[`startWith${cardValue.charAt(0)}`]();
    if (this.cardType) this.loadCardNumberFormatting[this.cardType]();
  }

  getCardTypeValues(itemValue) {
    return itemValue === '3'
      ? 'Amex'
      : itemValue === '4'
      ? 'Visa'
      : itemValue === '5'
      ? 'Master'
      : itemValue === '6'
      ? 'Discover'
      : '';
  }

  onChangeTxtCardNumberMob(event) {
    const cardValue = event.target.value;
    this.cardValue = cardValue;
    this.dumbcardno = this.cardValue;
    this.autoPay = false;
    this.cardType = this.getCardTypeValues(cardValue.charAt(0));
    if (cardValue.length > 0)
      this.loadCardTypeDetails[`startWith${cardValue.charAt(0)}`]();
    if (this.cardType) this.loadCardNumberFormatting[this.cardType]();
  }

  onChangeAutoTxtCardNumber(event) {
    const cardValue = event.target.value;
    this.autoPay = true;
    this.autoCardValue = cardValue;
    if (cardValue.length === 0) this.clearCardClassLists('noauto');
    this.autoCardType = this.getCardTypeValues(cardValue.charAt(0));
    if (cardValue.length > 0)
      this.loadCardTypeDetails[`startWith${cardValue.charAt(0)}`]();
    if (this.autoCardType)
      this.loadAutoCardNumberFormatting[this.autoCardType]();
  }
  clearAutoCardClassLists(cardValue: any) {
    const visa = document.getElementById('auto-card-details');
    if (cardValue === '' || cardValue === undefined) {
      visa.classList.remove('jp-card-identified');
      visa.classList.contains('jp-card-visa')
        ? visa.classList.remove('jp-card-visa')
        : '';
      visa.classList.contains('jp-card-amex')
        ? visa.classList.remove('jp-card-amex')
        : '';
      visa.classList.contains('jp-card-mastercard')
        ? visa.classList.remove('jp-card-mastercard')
        : '';
      visa.classList.contains('jp-card-discover')
        ? visa.classList.remove('jp-card-discover')
        : '';
    }
  }

  setCardNumberFormatted(cardNumber) {
    var formattedCardNumber = cardNumber.replace(/[^\d]/g, '');
    formattedCardNumber = formattedCardNumber.substring(0, 16);
    // Split the card number is groups of 4
    var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
    if (cardNumberSections !== null) {
      formattedCardNumber = cardNumberSections.join(' ');
    }
    return formattedCardNumber;
  }

  setAllCardNumberFormat() {
    this.cardNumberDisplay = this.cardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
    this.formattedCardNumber = this.cardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
  }

  setAllAutoCardNumberFormat() {
    this.autoCardNumberDisplay = this.autoCardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
    this.formattedAutoCardNumber = this.autoCardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
  }

  setAmexCardNumberFormat() {
    this.cardNumberDisplay = this.cardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
    this.formattedCardNumber = this.cardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
  }

  setAutoAmexCardNumberFormat() {
    this.autoCardNumberDisplay = this.autoCardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
    this.formattedAutoCardNumber = this.autoCardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
  }
  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }

  ngAfterViewInit(): void {
    this.ref.detach();
    setInterval(() => {
      if (!this.ref['destroyed']) {
        this.ref.detectChanges();
      }
    }, 0);
  }

  ngAfterContentChecked(): void {
    if (this.payDeposit === true) {
      this.validateDepositCards();
      this.validateCardNumberDetails();
      if (!this.autoPayment || !this.autoPay4CE)
        this.validateAutoCardNumberDetails();
      this.validateZipCodeDetails();
      this.validateAutoZipCodeDetails();
      this.validateMonthDetails();
      this.validateAutoMonthDetails();
      this.validateYearDetails();
      this.validateAutoYearDetails();
      this.validateSecurityCodeDetails();
      this.validateAutoSecurityCodeDetails();
      this.validateCardNameDetails();
      this.validateAutoCardNameDetails();
      this.validateCityDetails();
      this.validateAutoCityDetails();
      this.validateStreetAddressDetails();
      this.validateAutoStreetAddressDetails();
    }
  }

  validateDepositCards() {
    if (!this.autoPay4CE && !this.autoPayment) {
      if (
        this.validateDepositCardForAutopay() &&
        this.validateDepositCardForNoAutopay()
      ) {
        this.user_bot = true;
        this.isDisable = false;
      } else {
        this.postResponseMessage = '';
        this.user_bot = false;
        this.isDisable = true;
      }
    } else if (this.autoPay4CE || (!this.autoPay4CE && this.autoPayment)) {
      if (this.validateDepositCardForNoAutopay()) {
        this.user_bot = true;
        this.isDisable = false;
      } else {
        this.postResponseMessage = '';
        this.user_bot = false;
        this.isDisable = true;
      }
    }
  }

  validateDepositCardForNoAutopay() {
    if (
      this.formattedCardNumber != '' &&
      this.formattedCardNumber != undefined &&
      this.month != '' &&
      this.month != undefined &&
      this.year != '' &&
      this.year != undefined &&
      this.zipcode != '' &&
      this.zipcode != undefined &&
      this.street_address != undefined &&
      this.street_address != '' &&
      this.city != undefined &&
      this.city != '' &&
      !this.cvvValid &&
      this.validateCheckBoxes() &&
      this.cardName.length > 4 &&
      this.cardName != undefined
    ) {
      if (
        this.showmontherr !== true &&
        this.showAutoMmontherr !== true &&
        this.yearErrorFlag !== true &&
        this.autoYearErrorFlag !== true &&
        this.zipcode.length === 5 &&
        this.validCard != true
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  validateDepositCardForAutopay() {
    if (
      this.formattedAutoCardNumber != '' &&
      this.automonth != undefined &&
      this.autoyear != undefined &&
      this.autozipcode != '' &&
      this.autostreet_address != '' &&
      this.autocity != '' &&
      !this.cvvAutoValid &&
      this.validateCheckBoxes() &&
      this.autocardName.length > 4 &&
      this.autocardName != undefined
    ) {
      if (
        this.showmontherr !== true &&
        this.showAutoMmontherr !== true &&
        this.yearErrorFlag !== true &&
        this.autoYearErrorFlag !== true &&
        this.zipcode.length === 5 &&
        this.validCard != true
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  validateCheckBoxes() {
    this.checkBoxValue = this.autoPay4CE && this.acceptAutoPay ? true : false;
    if (
      !this.autoPay4CE &&
      this.acceptAutoPay === true &&
      this.acceptNoAutoPay === true
    )
      this.checkBoxValue = true;
    return this.checkBoxValue;
  }

  validateAutoPayCardDetails() {
    if (
      !this.autoPayment &&
      this.autodumbcardno === undefined &&
      this.automonth === undefined &&
      this.autoyear === undefined &&
      this.autozipcode === undefined &&
      this.autocardName === undefined &&
      this.autocity === undefined &&
      this.autostate === undefined
    ) {
      this.user_bot = false;
      this.isDisable = true;
    } else {
      if (
        this.showmontherr !== true &&
        this.yearErrorFlag !== true &&
        this.autozipcode &&
        this.autozipcode.length === 5 &&
        this.validCard != true &&
        !this.postResponseMessage
      ) {
        this.user_bot = true;
        this.isDisable = false;
      } else {
        this.user_bot = false;
        this.isDisable = true;
      }
    }
  }

  validateStreetAddressDetails() {
    const street_address = document.getElementById('street_address');
    if (street_address) {
      this.street_addressisNull = false;
      if (this.street_address !== '') {
        street_address.classList.remove('active-select');
      } else if (this.street_address === '') {
        street_address.classList.add('active-select');
        this.street_addressisNull = true;
      }
    }
  }

  validateAutoStreetAddressDetails() {
    const street_address = document.getElementById('autostreet_address');
    if (street_address) {
      this.autostreet_addressisNull = false;
      if (this.autostreet_address !== '') {
        street_address.classList.remove('active-select');
      } else if (this.autostreet_address === '') {
        street_address.classList.add('active-select');
        this.autostreet_addressisNull = true;
      }
    }
  }

  validateCityDetails() {
    const city = document.getElementById('city');
    if (city) {
      if (this.city !== '') {
        city.classList.remove('active-select');
        this.cityisNull = false;
      } else if (this.city === '') {
        city.classList.add('active-select');
        this.cityisNull = true;
      }
    }
  }

  validateAutoCityDetails() {
    const city = document.getElementById('city');
    if (city) {
      if (this.autocity !== '') {
        city.classList.remove('active-select');
        this.autocityisNull = false;
      } else if (this.autocity === '') {
        city.classList.add('active-select');
        this.autocityisNull = true;
      }
    }
  }

  validateCardNameDetails() {
    const cardname = document.getElementById('carddname');
    if (cardname) {
      if (this.cardName != '' && this.cardName != undefined) {
        cardname.classList.remove('active-select');
      } else if (this.cardName === '' && !this.checkCardName) {
        cardname.classList.add('active-select');
      }
    }
  }

  validateAutoCardNameDetails() {
    const cardname = document.getElementById('cardname');
    const carddname = document.getElementById('carddname');
    if (this.cardName != '' && this.cardName != undefined) {
      cardname.classList.remove('active-select');
      if (this.deviceWidth < 768) {
        carddname.classList.remove('active-select');
      }
    } else {
      if (carddname) cardname.classList.add('active-select');
      if (this.deviceWidth < 768) {
        carddname.classList.add('active-select');
      }
    }
  }

  validateSecurityCodeDetails() {
    const ccode = document.getElementById('ccode');
    if (ccode) {
      if (this.secuiritycode !== undefined && this.cvvValid != true) {
        this.ccodeisNull = false;
        ccode.classList.remove('active-select');
      } else if (
        (this.secuiritycode === '' || this.secuiritycode === undefined) &&
        this.cvvValid
      ) {
        this.ccodeisNull = true;
        ccode.classList.add('active-select');
      }
    }
  }

  validateAutoSecurityCodeDetails() {
    const cccode = document.getElementById('cccode');
    if (cccode) {
      if (this.autosecuiritycode !== '' && !this.cvvAutoValid) {
        this.cccodeisNull = false;
        if (this.deviceWidth < 768) {
          cccode.classList.remove('active-select');
        }
      } else if (this.autosecuiritycode === '' && this.cvvAutoValid) {
        this.cccodeisNull = true;
        cccode.classList.add('active-select');
      }
    }
  }
  validateYearDetails() {
    const cyear = document.getElementById('cyear');
    if (this.year != undefined && this.showmontherr != true) {
      cyear.classList.remove('active-select');
    } else {
      cyear.classList.add('active-select');
    }
  }

  validateAutoYearDetails() {
    const ccyear = document.getElementById('ccyear');
    if (ccyear) {
      if (this.year != undefined && this.showmontherr != true) {
        ccyear.classList.remove('active-select');
      } else {
        ccyear.classList.add('active-select');
      }
    }
  }

  validateMonthDetails() {
    const cmonth = document.getElementById('cmonth');
    if (cmonth) {
      if (this.month !== undefined && this.showmontherr != true) {
        cmonth.classList.remove('active-select');
      } else {
        cmonth.classList.add('active-select');
      }
    }
  }

  validateAutoMonthDetails() {
    const ccmonth = document.getElementById('ccmonth');
    if (this.automonth !== undefined && this.showmontherr != true) {
      ccmonth.classList.remove('active-select');
    } else {
      ccmonth.classList.add('active-select');
    }
  }

  validateZipCodeDetails() {
    const zipcode = document.getElementById('zipcode');
    if (zipcode) {
      if (this.zipcode !== '') {
        zipcode.classList.remove('active-select');
        this.zipcodeisNull = false;
      } else {
        zipcode.classList.add('active-select');
        this.zipcodeisNull = true;
      }
    }
  }

  validateAutoZipCodeDetails() {
    const zipcode = document.getElementById('autozipcode');
    if (zipcode) {
      if (this.autozipcode !== '') {
        zipcode.classList.remove('active-select');
        this.autozipcodeisNull = false;
      } else if (this.autozipcode === '') {
        zipcode.classList.add('active-select');
        this.autozipcodeisNull = true;
      }
    }
  }

  validateCardNumberDetails() {
    const txtCardNumber = document.getElementById('txtCardNumber');
    if (txtCardNumber) {
      if (this.formattedCardNumber !== undefined) {
        txtCardNumber.classList.remove('active-select');
        if (this.deviceWidth < 768) {
          txtCardNumber.classList.remove('active-select');
        }
      } else {
        txtCardNumber.classList.add('active-select');
        if (this.deviceWidth < 768) {
          txtCardNumber.classList.add('active-select');
        }
      }
    }
  }

  validateAutoCardNumberDetails() {
    const txtCardNumber = document.getElementById('txtAutoCardNumber');
    if (txtCardNumber) {
      if (
        this.formattedAutoCardNumber !== undefined ||
        this.formattedAutoCardNumber !== ''
      ) {
        txtCardNumber.classList.remove('active-select');
        if (this.deviceWidth < 768) {
          txtCardNumber.classList.remove('active-select');
        }
      } else if (
        this.formattedAutoCardNumber == undefined ||
        this.formattedAutoCardNumber === ''
      ) {
        txtCardNumber.classList.add('active-select');
        if (this.deviceWidth < 768) {
          txtCardNumber.classList.add('active-select');
        }
      }
    }
  }

  openModal1() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled1() {
    this.display = 'none';
  }

  validateccName(event) {
    let value = event.target.value;
    if (value.length > 4) {
      this.checkCardName = false;
    } else {
      this.checkCardName = true;
      }
      this.showmontherr = false
  }

  validateccAutoName(event) {
    let value = event.target.value;
    if (value.length > 4) {
      this.checkAutoCardName = false;
    } else {
      this.checkAutoCardName = true;
      }
      this.showmontherr = false
  }

  validateAutoCreditCardNumber() {
    this.autodumbcardno = this.formattedAutoCardNumber;
    if (this.isAmex) {
      this.formattedAutoCardNumber = this.formattedAutoCardNumber.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
      this.autoCardNumberDisplay = this.autoCardNumberDisplay.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
    } else {
      this.formattedAutoCardNumber = this.formattedAutoCardNumber.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
      this.autoCardNumberDisplay = this.autoCardNumberDisplay.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
    }
  }

  validateCreditCardNumber() {
    this.dumbcardno = this.formattedCardNumber;
    if (this.isAmex) {
      this.formattedCardNumber = this.formattedCardNumber.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
      this.cardNumberDisplay = this.cardNumberDisplay.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
    } else {
      this.formattedCardNumber = this.formattedCardNumber.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
      this.cardNumberDisplay = this.cardNumberDisplay.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
    }
  }

  setCardNumberDetails(cardNumber: string) {
    const visa = document.getElementById('jp-card-details');
    if (this.cardNumberDetails.charAt(0) === '4') {
      this.isVisa = true;
      visa.classList.add('jp-card-visa');
      visa.classList.add('jp-card-identified');
    }
  }

  validateAmexCardDetails() {
    this.maxLength = 15;
    this.isAmex = true;
    const visa = !this.autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-amex');
    visa.classList.add('jp-card-identified');
  }

  validateVisaCardDetails() {
    this.maxLength = 16;
    this.isVisa = true;
    const visa = !this.autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-visa');
    visa.classList.add('jp-card-identified');
  }

  validateMasterCardDetails() {
    this.maxLength = 16;
    const visa = !this.autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-mastercard');
    visa.classList.add('jp-card-identified');
  }

  validateDiscoveryDetails() {
    this.maxLength = 16;
    const visa = !this.autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-discover');
    visa.classList.add('jp-card-identified');
  }

  clearCardClassLists(itemValue) {
    const visa =
      itemValue === 'auto'
        ? document.getElementById('jp-card-details')
        : document.getElementById('auto-card-details');
    visa.classList.remove('jp-card-identified');
    visa.classList.contains('jp-card-visa')
      ? visa.classList.remove('jp-card-visa')
      : '';
    visa.classList.contains('jp-card-amex')
      ? visa.classList.remove('jp-card-amex')
      : '';
    visa.classList.contains('jp-card-mastercard')
      ? visa.classList.remove('jp-card-mastercard')
      : '';
    visa.classList.contains('jp-card-discover')
      ? visa.classList.remove('jp-card-discover')
      : '';
  }

  validate() {
    if (
      this.street_address === undefined ||
      this.street_address === '' ||
      this.city === undefined ||
      this.city === '' ||
      this.state === '' ||
      this.state === undefined ||
      this.zipcode === '' ||
      this.zipcode === undefined
    ) {
      this.user_bot = false;
      this.isDisable = true;
    } else {
      this.zipInvalidLength =
        this.zipcode && this.zipcode.length < 5 ? true : false;
      this.autozipInvalidLength =
        this.autozipcode && this.autozipcode.length < 5 ? true : false;
      this.street_address = this.street_address;
      this.apt = this.apt;
      this.city = this.city;
      this.zipcode = this.zipcode;
      }
      this.showmontherr = false
  }

  mailMe(mail) {
    mail = document.createElement('a');
    mail.href =
      'mailto:customercare@mychariotenergy.com?subject=Question&body=Hi';
    mail.click();
  }

  validateMonth() {
    if (this.month) {
      var d = new Date();
      var n = d.getMonth() + 1;

      if (this.year === new Date().getFullYear().toString() && this.month < n) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else if (this.month > 12) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankmontherr = false;
          this.showmontherr = false;
          this.user_bot = true;
          this.isDisable = false;
      }
    } else if (this.month.length === 0) {
      this.blankmontherr = true;
      this.showmontherr = false;
    }
  }

  validateAutoMonth() {
    if (this.automonth) {
      var d = new Date();
      var n = d.getMonth() + 1;

      if (
        this.autoyear === new Date().getFullYear().toString() &&
        parseInt(this.automonth) < n
      ) {
        this.showAutoMmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else if (parseInt(this.automonth) > 12) {
        this.showAutoMmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankmontherr = false;
        this.showAutoMmontherr = false;
      }
    } else if (this.automonth.length === 0) {
      this.blankmontherr = true;
      this.showAutoMmontherr = false;
    }
  }

  validateYear() {
    var d = new Date();
    var n = d.getMonth() + 1;
    if (this.year) {
      if (this.year < new Date().getFullYear().toString()) {
        this.yearErrorFlag = true;
        this.blankyearerr = false;
        this.user_bot = false;
        this.isDisable = true;
        this.year = '';
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.year === new Date().getFullYear().toString() &&
        this.month < n
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.year >= new Date().getFullYear().toString() &&
        this.month > 12
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankyearerr = false;
        this.showmontherr = false;
        this.yearErrorFlag = false;
          this.year = this.year;


          this.user_bot = true;
          this.isDisable = false;

      }
    } else if (this.year.length === 0) {
      this.blankyearerr = true;
      this.showmontherr = false;
    }
  }

  validateAutoYear() {
    var d = new Date();
    var n = d.getMonth() + 1;
    if (this.autoyear) {
      if (this.autoyear < new Date().getFullYear().toString()) {
        this.autoYearErrorFlag = true;
        this.blankyearerr = false;
        this.user_bot = false;
        this.isDisable = true;
        this.autoyear = '';
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.autoyear === new Date().getFullYear().toString() &&
        this.month < n
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.autoyear >= new Date().getFullYear().toString() &&
        this.month > 12
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankyearerr = false;
        this.showmontherr = false;
        this.autoYearErrorFlag = false;
        this.autoyear = this.autoyear;
      }
    } else if (this.year.length === 0) {
      this.blankyearerr = true;
      this.showmontherr = false;
    }
  }

  validatecvv(event, itemValue: string) {
    let value = event.target.value;
    const ccode = document.getElementById(
      itemValue === 'auto' ? 'ccode' : 'autoccode'
    );
    if (
      (this.cardType === 'Amex' && value.length < 4) ||
      (this.cardType !== 'Amex' && (value.length < 3 || value.length > 3))
    ) {
      this.cvvValid = true;
      ccode.classList.add('active-select');
    } else {
      this.cvvValid = false;
      ccode.classList.remove('active-select');
      }

      this.user_bot = true;
      this.isDisable = false;
  }

  validateAutoCvv(event, itemValue: string) {
    let value = event.target.value;
    const ccode = document.getElementById(
      itemValue === 'auto' ? 'ccode' : 'autoccode'
    );
    if (
      (this.autoCardType === 'Amex' && value.length < 4) ||
      (this.autoCardType !== 'Amex' && (value.length < 3 || value.length > 3))
    ) {
      this.cvvAutoValid = true;
      ccode.classList.add('active-select');
    } else {
      this.cvvAutoValid = false;
      ccode.classList.remove('active-select');
    }
  }

  flipCardForSecurityCode(cvvValue, itemValue) {
    let visa;
    if (itemValue === 'auto') {
      visa = document.getElementById('jp-card-details');
    } else if (itemValue === 'noauto') {
      visa = document.getElementById('auto-card-details');
    }
    return cvvValue === undefined || cvvValue === ''
      ? visa.classList.remove('jp-card-flipped')
      : visa.classList.add('jp-card-flipped');
  }

  flipCardFront(itemValue) {
    if (this.cardName !== undefined) {
      if (itemValue === 'auto') {
        const visa = document.getElementById('jp-card-details');
        visa.classList.remove('jp-card-flipped');
      } else if (itemValue === 'noauto') {
        const visa = document.getElementById('auto-card-details');
        visa.classList.remove('jp-card-flipped');
      }
    }
  }

  removeFile(removedfile) {
    const index = this.listofFiles.indexOf(removedfile);
    if (index > -1) {
      this.listofFiles.splice(index, 1);
    }
  }

  changeListener($event): void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.updata = myReader.result;
      this.updata = {
        filename: inputValue.files[0].name,
        filetype: 'image/jpeg',
        value: myReader.result.toString().split(',')[1],
      };
    };
    myReader.readAsDataURL(file);
  }

  sendApiDetails() {
    let depositObj;
    sessionStorage.removeItem('DepositError');
    sessionStorage.removeItem('DepositAutoError');
    var depositPaymentAccount = {
      CcAccountNumber: this.dumbcardno.replace(/\s/g, ''),
      CcExpirationDate: `${this.month}/${this.year}`,
      CcCVV: this.secuiritycode,
      Name: this.cardName,
      Address: this.street_address,
      City: this.city,
      State: this.state,
      Zip: this.zipcode,
      Description: this.description,
    };
    depositObj = {
      depositPaymentAccount: depositPaymentAccount,
      // autoPayPaymentAccount: this.autoPayPaymentAccount(),
      depositPaymentOptions: this.depositPaymentOptions,
    };
    depositObj = !this.residentialService.creditCheckResult4CE.autoPay4CE
      ? this.setAutoPayCardDetails(depositObj)
      : depositObj;
    this.openModal1();
    this.renderExternalScript(
      this.depositPaymentOptions.clientJavaScriptUrl
    ).onload = () => {
      // do something with this library
    };
    this.renderExternalScript(
      'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js'
    ).onload = () => {
      // do something with this library
    };

    setTimeout(function () {
      setupTransactisPaymentAccounts(depositObj);
    }, 2000);

    setTimeout(() => {
      this.navigateURLAfterDeposit();
    }, 10000);
  }

  setAutoPayCardDetails(depositObj) {
    let autoPayObj;
    if (!this.autoPayment) {
      autoPayObj = { ...depositObj, ...this.autoPayPaymentAccount() };
    } else if (this.autoPayment) {
      autoPayObj = { ...depositObj, ...this.copyCardDetailsWhenAutoPay() };
    }
    return autoPayObj;
  }

  autoPayPaymentAccount() {
    const user = {
      CcAccountNumber: this.autodumbcardno.replace(/\s/g, ''),
      CcExpirationDate: `${this.automonth}/${this.autoyear}`,
      CcCVV: this.autosecuiritycode,
      Name: this.autocardName,
      Address: this.autostreet_address,
      City: this.autocity,
      State: this.autostate,
      Zip: this.autozipcode,
      Description: this.autodescription,
    };
    return { autoPayPaymentAccount: user };
  }

  navigateURLAfterDeposit() {
    if (sessionStorage.getItem('DepositError') === 'PaymentError') {
      this.postResponseMessage = 'card1Error';
      this.onCloseHandled();
      return;
    }
    if (sessionStorage.getItem('DepositAutoError') === 'AutoPaymentError') {
      this.postResponseMessage = 'card2Error';
      this.onCloseHandled();
      return;
    }
    if (
      sessionStorage.getItem('depositCCTPAT') ||
      sessionStorage.getItem('autoPayCCTPAT')
    ) {
      this.saveCompleteCustomerEnrollment();
      this.autoPayCCTPAT = sessionStorage.getItem('autoPayCCTPAT');
      this.depositCCTPAT = sessionStorage.getItem('depositCCTPAT');
    }
  }

  saveCompleteCustomerEnrollment() {
    TriggerEventBeforeSubmitOrder(this.selectedProduct.energy_provider,this.selectedProduct.terms,this.selectedProduct.product_key,JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest')).zipcode, this.selectedProduct.utility_name, "residential");
    var beginCustomerEnrollmentRequest =
      this.residentialService.beginCustomerEnrollmentRequest;
    beginCustomerEnrollmentRequest.AccountNumber =
      this.residentialService.depositPaymentOption.accountNumber;
    const autoPayAndDepositObjects =
      this.loadAutoPayAndDepositObjects[
        !this.autoPay4CE && this.depositAmount4CE > 0
          ? 'autoPayDepositRequired'
          : this.autoPay4CE && this.depositAmount4CE === 0
          ? 'autoPayRequired'
          : ''
      ]();
    beginCustomerEnrollmentRequest = {
      ...beginCustomerEnrollmentRequest,
      ...autoPayAndDepositObjects,
    };
    let userObj = {
      postObject: beginCustomerEnrollmentRequest,
      energyProvider: this.providerContact.ProviderName,
      apiURL: this.providerContact.ProviderAPIURL,
    };
    this.residentialService
      .saveCompleteCustomerEnrollment(userObj)
      .subscribe((res: any) => {
        if (res.statusCode === 500) 
        {
          this.open4CEErrorTemplate();
          TriggerEventWhenOrderFailed('','Provider',this.selectedProduct.energy_provider,this.selectedProduct.terms,this.selectedProduct.product_key,JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest')).zipcode, this.selectedProduct.utility_name, "residential","enrollment")

        }else
        {
          this.residentialService.setConfirmationStatusDetails = res;
          this.assignOrderDetailsFor4CE(res);
          this.loadCompleteEnrollment[
            res.CompleteCustomerEnrollmentResult.ResponseType
          ]();
          this.TrackFunction("Success", this.residentialService.completeCustomerEnrollmentPostObject.Email);
        }
        
      });
  }

  autoPayDepositRequiredObject(beginCustomerEnrollmentRequest) {
    return {
      DespositTemporaryPaymentAccountToken:
        sessionStorage.getItem('depositCCTPAT'),
      AutoPayTemporaryPaymentAccountToken:
        sessionStorage.getItem('autoPayCCTPAT'),
      IsAutoPay: true,
      DepositRequired: true,
    };
  }

  autoPayRequiredObject() {
    return {
      AutoPayTemporaryPaymentAccountToken:
        sessionStorage.getItem('depositCCTPAT'),
      IsAutoPay: true,
    };
  }

  assignOrderDetailsFor4CE(res) {
    TriggerEventWhenOrderSuccess(res.CompleteCustomerEnrollmentResult.AccountNumber,this.selectedProduct.energy_provider,this.selectedProduct.terms,this.selectedProduct.product_key,JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest')).zipcode, this.selectedProduct.utility_name, "residential")
    let postObject =
        this.residentialService.completeCustomerEnrollmentPostObject,
      serviceTypeDateDetails = this.getServiceTypeValues(),
      isGetOrderRes = false,
      isNotificationRes = false,
      contactInfo = JSON.parse(sessionStorage.getItem('userObj'));
    this.selectedProduct.energy_provider_image =
      this.selectedProduct.energy_provider_image_cloud;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.recommendationService.hg_accountId,
      ConfirmationNumber: res.CompleteCustomerEnrollmentResult.AccountNumber,
      status:
        res.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
          ? 'Completed'
          : res.CompleteCustomerEnrollmentResult.ResponseType,
      isDepositRequired:
        this.residentialService.creditCheckResult4CE.depositRequired4CE,
      webStatus:
        res.CompleteCustomerEnrollmentResult.ResponseType === 'Success'
          ? 'Completed'
          : res.CompleteCustomerEnrollmentResult.ResponseType,
      reason: '',
      creditCheckResults: '',
      customerId: res.CompleteCustomerEnrollmentResult.AccountNumber,
      enableSMSForHonest: postObject.enableSMSForHonest === true ? 'Yes' : 'No',
      enableSMSForChariot: '',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: postObject.FirstName,
        legalLastName: postObject.LastName,
        emailId: postObject.Email,
        phoneNo: postObject.HomePhone,
        language: postObject.language,
        dob: postObject.DateOfBirth,
        authorizedRep: postObject.authorizedRep,
      },
      esiid: postObject.ServiceAddress.EsiId,
      invoiceType: postObject.invoiceType,
      promoDetails: {
        hearusOption: postObject.hearusOption,
        promoeCode: postObject.promoeCode,
      },
      privateDetails: {
        state: this.state,
        license: postObject.license,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    this.recommendationService.enrollmentOrderDetails = orderDetails;
  }

  saveEnrollmentOrderDetails() {
    
    const orderDetails = this.recommendationService.enrollmentOrderDetails;
    const body = new HttpParams().append(
      'orderDetails',
      JSON.stringify(orderDetails)
    );
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      console.log(res);
      this.sendCongratsMail();
      this.router.navigate([
        'congrats',
        this.recommendationService.hg_accountId,
      ]);
      this.onCloseHandled();
    });
  }

  sendCongratsMail() {
    const userObj = {
      hg_accountId: this.recommendationService.hg_accountId,
      esiid:
        this.residentialService.beginCustomerEnrollmentRequest.ServiceAddress
          .EsiId,
      emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
    };
    this.providerContact.ProviderLogo =
      this.residentialService.renameEnergyProviderName(
        this.selectedProduct.energy_provider
      );
    const body = new HttpParams();
    body.append('userDetails', JSON.stringify(userObj));
    body.append('providerContact', JSON.stringify(this.providerContact));
    this.http.post(this.url + '/congratsEmail', body).subscribe((res: any) => {
      this.spinner.hide();
      const result = res;
    });
  }

  serviceTypeExpireDate(startDate) {
    let term = this.recommendationService.signupProduct.terms,
      expiredDate =
        startDate !== 'Priority Move-In' && startDate !== 'Standard Switch'
          ? new Date(startDate)
          : new Date();
    expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
    return this.suffixDateTimeToSelectedSwitchDate(expiredDate);
  }

  getServiceTypeValues() {
    let serviceType, expiredDate, responses, switchObj, serviceTypeObj;
      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null) {

    responses = JSON.parse(sessionStorage.getItem('userResponse'));
    this.userResponses = responses.userResponses;
    this.residentialService.userResponse['userResponses'] = this.userResponses;
    if (!_.isEmpty(this.userResponses)) {
      switchObj = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      serviceType = switchObj.fieldValue;
      serviceTypeObj =
        this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
      expiredDate = this.expiratonDateFromQuestion();
    }
    return {
      serviceType: serviceType,
      switchType: serviceTypeObj.switchType,
      switchDate: serviceTypeObj.startDate,
      moveInType: serviceTypeObj.switchType,
      expiredDate: expiredDate,
          };
      } else {

          var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
          //this.userResponses = responses.userResponses;
          //this.residentialService.userResponse['userResponses'] = this.userResponses;
          if (!_.isEmpty(responses__)) {
              switchObj = _.findWhere(responses__, {
                  res_question_id: '002',
              });
              serviceType = switchObj.fieldValue;
              serviceTypeObj =
                  this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
              expiredDate = this.expiratonDateFromQuestion();
          }
          return {
              serviceType: serviceType,
              switchType: serviceTypeObj.switchType,
              switchDate: serviceTypeObj.startDate,
              moveInType: serviceTypeObj.switchType,
              expiredDate: expiredDate,
          };
      }
  }
  expiratonDateFromQuestion() {
    let expiredDate;
    const expireObj = _.findWhere(this.userResponses, {
      res_question_id: '003',
    });
    if (!_.isEmpty(expireObj) && typeof expireObj.fieldValue !== 'string') {
      const date = JSON.parse(expireObj.fieldValue.date);
      expiredDate = this.getServiceTypeDateObj(date);
    } else if (
      !_.isEmpty(expireObj) &&
      typeof expireObj.fieldValue === 'string'
    ) {
      expiredDate = expireObj.fieldValue;
    }
    return expiredDate !== undefined ? expiredDate : '';
  }

  suffixDateTimeToSelectedSwitchDate(expiredDate) {
    var d = new Date(expiredDate);
    return (
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
      ' ' +
      [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':')
    );
  }

  assignServiceTypeValuesForNewService() {
      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null) {


    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
          return { switchType: switchType, startDate: startDate };
      } else {
          var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));

          const switchDateObj = _.findWhere(responses__, {
              res_question_id: '007',
          });
          let switchType, startDate;
          if (!_.isEmpty(switchDateObj)) {
              switchType = switchDateObj.startDateType;
              if (
                  switchDateObj.startDateType &&
                  switchDateObj.startDateType === 'Priority Move-In'
              ) {
                  startDate = 'Priority Move-In';
              } else {
                  const someDate = new Date();
                  someDate.setDate(someDate.getDate() + 2);
                  startDate =
                      new Date(switchDateObj.fieldValue) < someDate
                          ? 'Priority Move-In'
                          : this.getServiceTypeDateObj(switchDateObj.fieldValue);
              }
          }
          return { switchType: switchType, startDate: startDate };

      }
  }

  getServiceTypeDateObj(dateObj) {
    return (
      this.pad(new Date(dateObj).getMonth() + 1) +
      '/' +
      new Date(dateObj).getDate() +
      '/' +
      new Date(dateObj).getFullYear()
    );
  }
  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  assignServiceTypeValuesForStandardSwitch(): any {


      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null) {


          const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
          let startDate,
              switchType = obj.fieldValue;
          if (switchType === 'Standard Switch') {
              startDate = 'Standard Switch';
          } else {
              const dateObj = _.findWhere(this.userResponses, {
                  res_question_id: '005',
              });
              startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
          }
          return { switchType: switchType, startDate: startDate };
      } else {
            var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
            const obj = _.findWhere(responses__, { res_question_id: '004' });
            let startDate,
                switchType = obj.fieldValue;
            if (switchType === 'Standard Switch') {
                startDate = 'Standard Switch';
            } else {
                const dateObj = _.findWhere(responses__, {
                    res_question_id: '005',
                });
                startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
            }
            return { switchType: switchType, startDate: startDate };
        }
  }

  onCloseHandled() {
    this.display = 'none';
  }

  autoPayOptionClick(event) {
    if (this.deviceWidth < 768) this.autoPayment = true;
    else {
      if (event.target.value === 'autoPayment') this.autoPayment = true;
    }
  }

  copyCardDetailsWhenAutoPay() {
    const user = {
      CcAccountNumber: this.dumbcardno.replace(/\s/g, ''),
      CcExpirationDate: `${this.month}/${this.year}`,
      CcCVV: this.secuiritycode,
      Name: this.cardName,
      Address: this.street_address,
      City: this.city,
      State: this.state,
      Zip: this.zipcode,
      Description: this.description,
    };
    return { autoPayPaymentAccount: user };
  }

  ngOnDestroy() {
    sessionStorage.removeItem('autoPayCCTPAT');
    sessionStorage.removeItem('depositCCTPAT');
    sessionStorage.removeItem('DepositError');
    sessionStorage.removeItem('DepositAutoError');
  }

  validateSecurityCode(itemValue) {
    return itemValue === 'auto'
      ? this.secuiritycode
        ? this.secuiritycode
        : '***'
      : this.autosecuiritycode
      ? this.autosecuiritycode
      : '***';
  }

  validateCardDisplay(itemValue) {
    return itemValue === 'auto'
      ? this.formattedCardNumber
        ? this.formattedCardNumber
        : '**** **** **** ****'
      : this.formattedAutoCardNumber
      ? this.formattedAutoCardNumber
      : '**** **** **** ****';
  }

  validateFullName(event) {
    return event === 'auto'
      ? this.cardName
        ? this.cardName
        : 'Full Name'
      : this.autocardName
      ? this.autocardName
      : 'Full Name';
  }

  setCardTextAutoPayBased() {
    return this.autoPay4CE
      ? 'Card Number'
      : 'For Deposit Purposes - Enter Card Number*';
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  creditCardErrorResponse() {
    if (this.postResponseMessage)
      return this.loadCreditCardErrorMessages[this.postResponseMessage];
  }

  open4CEErrorTemplate() {
    const template: ElementRef<any> = this.errorStatus4CE;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }
  closeEnrollmentStatusTemplate() {
    this.modalRef.hide();
    this.router.navigate(['/']);
  }

  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    // append to head of document
    
    document.getElementsByTagName('head')[0].appendChild(node); 
  
    let script = this.renderer.createElement('script');
    script.setAttribute('id', 'ChatScript');
    script.text = `
        (function(d, w, c) {
          w.BrevoConversationsID = '649dacacdbc74231a94a3297';
          w[c] = w[c] || function() {
              (w[c].q = w[c].q || []).push(arguments);
          };
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
          if (d.head) d.head.appendChild(s);
      })(document, window, 'BrevoConversations');
    `;
  
    const existingScript = document.getElementById("ChatScript");
    if (!existingScript) {
      
    document.getElementsByTagName('head')[0].appendChild(script); 
    }
  }

  
TrackFunction(Status,Email)
{
  
  var product = this.selectedProduct
  var value = sessionStorage.getItem('esiidValue')
  var subString = value != null ? value.substring(value.length - 5) : "";

  CallTrack_function(
    "EnrollmentSubmit",
    product.energy_provider, 
    product.product_key, 
    product.terms, 
    (product.tier[0].avg_charge * 100).toFixed(1),
    (product.tier[1].avg_charge * 100).toFixed(1),
    (product.tier[2].avg_charge * 100).toFixed(1),
    subString,  
    product.utility_name, 
    Status,Email );

}
}
